var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (_)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Configurator } from "@api/services/configurator";
// import { Config } from "codelyzer";
var MonthlyTariffPriceBox = /*@__PURE__*/ (function () {
    function MonthlyTariffPriceBox(container) {
        this.PLACEHOLDER_PROMO_TEXT = "{PLACEHOLDER_PROMO_TEXT}";
        this.promoText = "";
        this.template = ' <div class="price-box">\n' +
            '                                        <div class="price-box__price" id="tariff-price-box-id">\n' +
            '                                            <span class="price-box__price-euro">00</span>\n' +
            '                                            <span class="price-box__price-cent-period">\n' +
            '                                                <span class="price-box__price-cent">00 €</span>\n' +
            '                                                <span class="price-box__price-period">pro Monat</span>\n' +
            "                                           </span>\n" +
            '                                                <span class="price-box__promo-pricing">\n' +
            '                                                    <span class="price-box__strikeprice strikeprice"></span>\n' +
            "                                                </span>\n" +
            "                                        </div>\n" +
            '                                            <div class="price-box__promo-text">' +
            "                                            " +
            this.PLACEHOLDER_PROMO_TEXT +
            "                                            </div>\n" +
            "                                    </div>";
        this.container = container;
        this.init();
    }
    MonthlyTariffPriceBox.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.tariffId = this.container.dataset.tariffId
                            ? parseInt(this.container.dataset.tariffId)
                            : null;
                        this.subTariffId =
                            this.container.dataset.subTariffId != ""
                                ? parseInt(this.container.dataset.subTariffId)
                                : null;
                        this.promoText = this.container.dataset.promoText
                            ? this.container.dataset.promoText
                            : "";
                        this.template = this.template.replace(this.PLACEHOLDER_PROMO_TEXT, this.promoText);
                        this.container.innerHTML = this.template;
                        if (!this.tariffId)
                            return [3 /*break*/, 2];
                        Configurator.subscribe("offerChanged", this.onOfferChanged.bind(this));
                        return [4 /*yield*/, this.onOfferChanged()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        window.addEventListener("priceBoxContainerLoaded", function (e) {
                            var selectedTariffId = Configurator.getTariff().id;
                            _this.updateFromSelected(selectedTariffId);
                        });
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    MonthlyTariffPriceBox.prototype.onOfferChanged = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.setPrice()];
                    case 1:
                        _a.sent();
                        window.dispatchEvent(new CustomEvent("priceBoxContainerLoaded", {}));
                        return [2 /*return*/];
                }
            });
        });
    };
    MonthlyTariffPriceBox.prototype.setPrice = function () {
        return __awaiter(this, void 0, void 0, function () {
            var offer, tariffId, tariffIdForOffer, _a, price, monthlyDiscounts, priceAfterFirstYear, strikePrice;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        tariffId = this.tariffId;
                        return [4 /*yield*/, Configurator.getCoPaymentState()];
                    case 1:
                        _a = (_b.sent()) ===
                            1 /* TOGGLE_ON */;
                        if (!_a)
                            return [3 /*break*/, 3];
                        return [4 /*yield*/, Configurator.hasDeviceDetailModule()];
                    case 2:
                        _a = (_b.sent());
                        _b.label = 3;
                    case 3:
                        tariffIdForOffer = _a &&
                            this.subTariffId
                            ? this.subTariffId
                            : this.tariffId;
                        return [4 /*yield*/, Configurator.calculateOfferForTariff(tariffIdForOffer)];
                    case 4:
                        offer = _b.sent();
                        price = offer.getMonthlyPrice();
                        monthlyDiscounts = offer.getMonthlyDiscounts();
                        priceAfterFirstYear = offer.getMonthlyPriceAfterFirstYear();
                        strikePrice = monthlyDiscounts.length > 0 ? priceAfterFirstYear : null;
                        /*
                        if(Configurator.getTariff().id === this.tariffId){
                            console.log(tariffIdForOffer);
                            console.log(offer);
                            console.log(price);
                            console.log(strikePrice);
                        }
                        */
                        offer && this.updatePriceOfTariff(price, tariffId, strikePrice);
                        return [2 /*return*/];
                }
            });
        });
    };
    MonthlyTariffPriceBox.prototype.updatePriceOfTariff = function (price, id, strikePrice) {
        var priceBox = this.container;
        var fullPrice = priceBox.querySelector(".price-box__price-euro");
        var decimalPrice = priceBox.querySelector(".price-box__price-cent");
        var strikePriceElements = Array.prototype.slice.call(this.container.querySelectorAll(".strikeprice"));
        var priceString = price.toFixed(2).toString().split(".");
        fullPrice.textContent = priceString[0];
        decimalPrice.textContent =
            priceString.length > 1 ? priceString[1] + " €" : "00 €";
        if (strikePrice) {
            var strikePriceText_1 = (strikePrice.toFixed(2) + " €").replace(".", ",");
            // includes promo text
            strikePriceElements.forEach(function (strikePriceEl) {
                strikePriceEl.textContent = strikePriceText_1;
                strikePriceEl.classList.remove("hidden");
            });
        }
        else {
            strikePriceElements.forEach(function (strikePriceEl) {
                strikePriceEl.textContent = "";
                strikePriceEl.classList.add("hidden");
            });
        }
    };
    MonthlyTariffPriceBox.prototype.updateFromSelected = function (selectedTariffId) {
        var promoTextContainer = this.container.querySelector(".price-box__promo-text");
        var priceBoxEuroContainer = this.container.querySelector(".price-box__price-euro");
        var priceBoxCentsContainer = this.container.querySelector(".price-box__price-cent");
        var strikePriceContainer = this.container.querySelector(".price-box__strikeprice");
        var containerSelectedTariff = document.querySelector('.mod-ep-kiss-tariffs__price-box-container[data-tariff-id="' +
            selectedTariffId +
            '"]');
        var priceBoxEuro = containerSelectedTariff.querySelector(".price-box__price-euro");
        var priceBoxCents = containerSelectedTariff.querySelector(".price-box__price-cent");
        var strikePrice = containerSelectedTariff.querySelector(".price-box__strikeprice");
        var promoText = containerSelectedTariff.querySelector(".price-box__promo-text");
        priceBoxEuroContainer.textContent = priceBoxEuro
            ? priceBoxEuro.textContent
            : "";
        priceBoxCentsContainer.textContent = priceBoxCents
            ? priceBoxCents.textContent
            : "";
        strikePriceContainer.textContent = strikePrice
            ? strikePrice.textContent
            : "";
        promoTextContainer.innerHTML = promoText ? promoText.innerHTML : "";
    };
    return MonthlyTariffPriceBox;
}());
export default MonthlyTariffPriceBox;



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/shop-builder/shared/MonthlyTariffPriceBox.ts
// module id = null
// module chunks = 